import { useEffect } from 'react';

const useAppInit = () => {
  if ('scrollRestoration' in history) {
    history.scrollRestoration = 'manual';
  }
  useEffect(() => {
    const handleEvent = (event: Event) => {
      event?.preventDefault();
    };
    document.addEventListener('copy', handleEvent);
    document.addEventListener('contextmenu', handleEvent);
    return () => {
      document.removeEventListener('copy', handleEvent);
      document.removeEventListener('contextmenu', handleEvent);
    };
  }, []);
};

export default useAppInit;
